import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'elements';

import { PromoPriceStyled } from './PromoPrice.styled';

const PromoPrice = ({ modifiers, oldPrice, newPrice }) => (
  <PromoPriceStyled modifiers={modifiers}>
    <Text modifiers={['brandFont', 'small', 'noLineHeight', 'lineThrough', 'lightGrayColor']} content={oldPrice} />
    <Text modifiers={['brandFont', 'small', 'brandColor', 'bold', 'noLineHeight']} content={newPrice} />
  </PromoPriceStyled>
);

PromoPrice.propTypes = {
  oldPrice: PropTypes.string,
  newPrice: PropTypes.string,
  modifiers: PropTypes.any,
};

export default PromoPrice;
